module.exports = __webpack_public_path__ + "static/img/jin_jkfa_icon.png";